import {useState, useCallback} from 'react';

export interface UseTourOptions {
  storageKey?: string;
  initialOpen?: boolean;
}

/**
 * Custom hook for managing tour state and persistence
 * Integrates with sessionStorage to persist tour closure across sessions
 */
export function useTour(options?: UseTourOptions) {
  const {storageKey = 'hasClosedTour', initialOpen = false} = options || {};

  const [isOpen, setIsOpen] = useState(() => {
    const hasClosedTour = sessionStorage.getItem(storageKey) === 'true';
    return !hasClosedTour && initialOpen;
  });

  const closeTour = useCallback(() => {
    setIsOpen(false);
    sessionStorage.setItem(storageKey, 'true');
  }, [storageKey]);

  const openTour = useCallback(() => {
    setIsOpen(true);
    sessionStorage.removeItem(storageKey);
  }, [storageKey]);

  const resetTour = useCallback(() => {
    setIsOpen(true);
    sessionStorage.removeItem(storageKey);
  }, [storageKey]);

  return {
    isOpen,
    closeTour,
    openTour,
    resetTour,
    onRequestClose: closeTour,
  };
}

export default useTour;
